/* ===============================
  Модули с отложенной загрузкой
=============================== */

export enum FeedbackCmsComponents {
  SdCMSCompanyFeedbackComponent = 'SdCMSCompanyFeedbackComponent',
  SdCMSCompanyFeedbackListComponent = 'SdCMSCompanyFeedbackListComponent',
  SdCMSCompanyFeedbackDetailsComponent = 'SdCMSCompanyFeedbackDetailsComponent',
}

export enum ArticleCmsComponents {
  RosaCMSArticleDetailDateComponent = 'RosaCMSArticleDetailDateComponent',
  RosaCMSArticleDetailReadingTimeComponent = 'RosaCMSArticleDetailReadingTimeComponent',
  RosaCMSArticleDetailTableOfContentComponent = 'RosaCMSArticleDetailTableOfContentComponent',
  RosaCMSArticleDetailAuthorComponent = 'RosaCMSArticleDetailAuthorComponent',
  RosaCMSArticleDetailRatingComponent = 'RosaCMSArticleDetailRatingComponent',
  RosaCMSArticleDetailCrossLinksComponent = 'RosaCMSArticleDetailCrossLinksComponent',
  RosaCMSArticleDetailComponent = 'RosaCMSArticleDetailComponent',
  SdCMSArticleListComponent = 'SdCMSArticleListComponent',
}

export enum CompanyCmsComponents {
  AddCompanyComponent = 'AddCompanyComponent',
}

export enum SearchComponents {
  SearchBoxComponent = 'SearchBoxComponent',
}

export enum ReferencesCmsComponents {
  RetailRocketProductReferencesComponent = 'RetailRocketProductReferencesComponent',
  RetailRocketCartReferencesComponent = 'RetailRocketCartReferencesComponent',
  RetailRocketCatalogReferencesComponent = 'RetailRocketCatalogReferencesComponent',
  RetailRocketUserReferencesComponent = 'RetailRocketUserReferencesComponent',
  RetailRocketWishListReferencesComponent = 'RetailRocketWishListReferencesComponent',
  RetailRocketComparisonReferencesComponent = 'RetailRocketComparisonReferencesComponent',
}

export enum CustomProductCmsComponents {
  ProductIntroComponent = 'ProductIntroComponent',
  ProductReferencesComponent = 'ProductReferencesComponent',
  ProductCarouselComponent = 'ProductCarouselComponent',
  ProductGroupReferencesComponent = 'ProductGroupReferencesComponent',
  ProductSpecsTabComponent = 'ProductSpecsTabComponent',
  ProductMainSpecsComponent = 'ProductMainSpecsComponent',
  ProductAddToCartComponent = 'ProductAddToCartComponent',
  SdCMSProductPriceComponent = 'SdCMSProductPriceComponent',
  SdCMSProductDataSheetTabComponent = 'SdCMSProductDataSheetTabComponent',
  SdCMSProductAvailabilityComponent = 'SdCMSProductAvailabilityComponent',
  ProductReviewsTabComponent = 'ProductReviewsTabComponent',
  SdCMSProductMarketingAttributesComponent = 'SdCMSProductMarketingAttributesComponent',
  ProductImagesComponent = 'ProductImagesComponent',
  ProductDetailsTabComponent = 'ProductDetailsTabComponent',
  CMSTabParagraphContainer = 'CMSTabParagraphContainer',
  SdCMSProductArticlesTabComponent = 'SdCMSProductArticlesTabComponent',
  SdCMSCalculatorComponent = 'SdCMSCalculatorComponent',
  RosaCMSManualPriceComponent = 'RosaCMSManualPriceComponent',
  RosaCMSProductCardComponent = 'RosaCMSProductCardComponent',
  RosaCMSProductScrollToCalculatorComponent = 'RosaCMSProductScrollToCalculatorComponent',
}

export enum CustomProductListCmsComponents {
  ProductGridComponent = 'ProductGridComponent',
  CMSProductListComponent = 'CMSProductListComponent',
  SearchResultsGridComponent = 'SearchResultsGridComponent',
  SearchResultsListComponent = 'SearchResultsListComponent',
  CategoryTagsComponent = 'CategoryTagsComponent',
  ProductRefinementComponent = 'ProductRefinementComponent',
  SdCMSSearchTapsComponent = 'SdCMSSearchTapsComponent',
  SdCMSProductListSmartFoundComponent = 'SdCMSProductListSmartFoundComponent',
}

export enum PromoCmsComponents {
  SimpleBannerComponent = 'SimpleBannerComponent',
  SimpleResponsiveBannerComponent = 'SimpleResponsiveBannerComponent',
  SdCMSCatalogBannerComponent = 'SdCMSCatalogBannerComponent',
  SdTitledBannerComponent = 'SdTitledBannerComponent',
  RosaCMSSubstrateResponsiveBannerComponent = 'RosaCMSSubstrateResponsiveBannerComponent',
  TimestampResponsiveBannerComponent = 'TimestampResponsiveBannerComponent',
  RosaRotatingImagesComponent = 'RosaRotatingImagesComponent',
  RotatingImagesComponent = 'RotatingImagesComponent',
  RandomBannerComponent = 'RandomBannerComponent',
  RosaFormattedResponsiveBannerComponent = 'RosaFormattedResponsiveBannerComponent',
  RosaFormattedResponsiveBannerMultiLineCarouselComponent = 'RosaFormattedResponsiveBannerMultiLineCarouselComponent',
  RosaFormattedResponsiveBannerOneLineCarouselComponent = 'RosaFormattedResponsiveBannerOneLineCarouselComponent',
}

export enum BetonCmsComponents {
  RosaCMSBetonOrderComponent = 'RosaCMSBetonOrderComponent',
  RosaCMSBetonOrderModalComponent = 'RosaCMSBetonOrderModalComponent',
}

/* ================================
  Модули с безотложной загрузкой
================================ */

export enum CityCmsComponents {
  SdCMSCitySelectHeaderComponent = 'SdCMSCitySelectHeaderComponent',
  SdCMSCitySelectComponent = 'SdCMSCitySelectComponent',
}

export enum MainCmsComponents {
  SdCMSCategoriesMenuComponent = 'SdCMSCategoriesMenuComponent',
  MobileMenuComponent = 'MobileMenuComponent',
  SdCMSPagesNavigationComponent = 'SdCMSPagesNavigationComponent',
  SdSitemapComponent = 'SdSitemapComponent',
  SdCMSChatLinkComponent = 'SdCMSChatLinkComponent',
  SdCMSTalkMeComponent = 'SdCMSTalkMeComponent',
  CmsOpenMobileCategoriesComponent = 'CmsOpenMobileCategoriesComponent',
  SdCMSChatMobileMenuComponent = 'SdCMSChatMobileMenuComponent',
}

// TODO: https://it-labs.atlassian.net/browse/HYB2-2706
export enum CustomUserCmsComponents {
  SdCMSCallbackComponent = 'SdCMSCallbackComponent',
  LoginComponent = 'LoginComponent',
  SdCMSLoginButtonComponent = 'SdCMSLoginButtonComponent',
  ReturningCustomerLoginComponent = 'ReturningCustomerLoginComponent',
  SdCMSLoginMenuNavigationComponent = 'SdCMSLoginMenuNavigationComponent',
  OrderByPhoneDialogComponent = 'OrderByPhoneDialogComponent',
  PayOrderDialogComponent = 'PayOrderDialogComponent',
  ReportIssueDialogComponent = 'ReportIssueDialogComponent',
  TrackOrderDialogComponent = 'TrackOrderDialogComponent',
  SwitchProfileComponent = 'SwitchProfileComponent',
  LoginLoyaltyComponent = 'LoginLoyaltyComponent',
}

export enum ComparisonCmsComponents {
  RosaCMSComparisonMainComponent = 'RosaCMSComparisonMainComponent',
  RosaCMSComparisonComponent = 'RosaCMSComparisonComponent',
}

export enum DeliveryCmsComponents {
  SdCMSDeliveryCalculatorFormComponent = 'SdCMSDeliveryCalculatorFormComponent',
  SdCMSDeliveryMapComponent = 'SdCMSDeliveryMapComponent',
}

export enum PaymentCmsComponents {
  RosaCMSPaymentsComponent = 'RosaCMSPaymentsComponent',
}

export enum BadgesComponents {
  SdCMSRequestCouponFormComponent = 'SdCMSRequestCouponFormComponent',
}

export enum WishlistCmsComponents {
  RosaCMSWishlistButtonComponent = 'RosaCMSWishlistButtonComponent',
  RosaCMSWishlistContentComponent = 'RosaCMSWishlistContentComponent',
}

export enum TrackingCmsComponents {
  SdCMSTrackingComponent = 'SdCMSTrackingComponent',
  PickupTrackingComponent = 'PickupTrackingComponent',
}
